import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { JwtComponent } from './jwt.component';

export const routes: Routes = [{ path: '', component: JwtComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JwtRoutesModule {}
